import { Chart as ChartJS, CategoryScale, LinearScale, Tooltip, Legend, PointElement, LineElement, BarElement, Title, Filler, defaults } from 'chart.js';
import crosshair from 'chartjs-plugin-crosshair';
import Zoom from 'chartjs-plugin-zoom';
export default function setupCharts() {
    defaults.font.family = 'Lora';
    var imageCache = new Map();
    var lineChartIcons = {
        id: 'lineChartIcons',
        beforeDraw: function (chart, args, options) {
            if (options.enabled === false)
                return; // Check if the plugin is disabled
            var icons = options.icons;
            icons.forEach(function (icon) {
                if (icon.show === false)
                    return;
                if (!imageCache.has(icon.icon)) {
                    var img = new Image();
                    img.src = icon.icon;
                    imageCache.set(icon.icon, img);
                }
            });
        },
        afterDatasetsDraw: function (chart, args, options) {
            if (options.enabled === false)
                return; // Check if the plugin is disabled
            var ctx = chart.ctx, _a = chart.chartArea, top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right, _b = chart.scales, x = _b.x, y = _b.y;
            var icons = options.icons;
            icons.forEach(function (_a) {
                var icon = _a.icon, xVal = _a.x, yVal = _a.y, circle = _a.circle, outlineColor = _a.outlineColor, show = _a.show;
                if (show === false)
                    return;
                var img = imageCache.get(icon);
                if (img && img.complete && img.naturalHeight !== 0) {
                    var xCoord = x.getPixelForValue(xVal);
                    var yCoord = y.getPixelForValue(yVal);
                    if (circle) {
                        ctx.save();
                        ctx.beginPath();
                        ctx.arc(xCoord, yCoord, 9, 0, 2 * Math.PI);
                        ctx.clip();
                        ctx.drawImage(img, xCoord - 9, yCoord - 9, 18, 18);
                        ctx.restore();
                        ctx.beginPath();
                        ctx.arc(xCoord, yCoord, 9, 0, 2 * Math.PI);
                        ctx.lineWidth = 2;
                        ctx.strokeStyle = outlineColor;
                        ctx.stroke();
                    }
                    else {
                        ctx.drawImage(img, xCoord - 9, yCoord - 9, 18, 18);
                    }
                }
            });
        },
        order: 0,
    };
    var drawStar = function (ctx, cx, cy, spikes, outerRadius, innerRadius, rotation) {
        if (rotation === void 0) { rotation = 0; }
        var rot = Math.PI / 2 * 3;
        var x = cx;
        var y = cy;
        var step = Math.PI / spikes;
        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(rotation);
        ctx.translate(-cx, -cy);
        // draw the black outline first
        ctx.beginPath();
        ctx.moveTo(cx, cy - outerRadius);
        for (var i = 0; i < spikes; i++) {
            x = cx + Math.cos(rot) * outerRadius;
            y = cy + Math.sin(rot) * outerRadius;
            ctx.lineTo(x, y);
            rot += step;
            x = cx + Math.cos(rot) * innerRadius;
            y = cy + Math.sin(rot) * innerRadius;
            ctx.lineTo(x, y);
            rot += step;
        }
        ctx.lineTo(cx, cy - outerRadius);
        ctx.closePath();
        ctx.lineWidth = 7; // slightly thicker for the black outline
        ctx.strokeStyle = 'black';
        ctx.stroke();
        // draw the gold outline and fill
        ctx.beginPath();
        ctx.moveTo(cx, cy - outerRadius);
        rot = Math.PI / 2 * 3; // reset rotation
        for (var i = 0; i < spikes; i++) {
            x = cx + Math.cos(rot) * outerRadius;
            y = cy + Math.sin(rot) * outerRadius;
            ctx.lineTo(x, y);
            rot += step;
            x = cx + Math.cos(rot) * innerRadius;
            y = cy + Math.sin(rot) * innerRadius;
            ctx.lineTo(x, y);
            rot += step;
        }
        ctx.lineTo(cx, cy - outerRadius);
        ctx.closePath();
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'rgb(218, 165, 32)';
        ctx.stroke();
        ctx.fillStyle = 'rgba(218, 165, 32, 0.8)';
        ctx.fill();
        ctx.restore();
    };
    var drawRoundedRect = function (ctx, x, y, width, height, radius) {
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
    };
    var drawImageWithBorder = function (ctx, img, x, y, width, height, borderWidth, borderColor, borderRadius) {
        ctx.save();
        ctx.fillStyle = borderColor;
        drawRoundedRect(ctx, x - borderWidth, y - borderWidth, width + 2 * borderWidth, height + 2 * borderWidth, borderRadius);
        ctx.fill();
        ctx.restore();
        ctx.save();
        drawRoundedRect(ctx, x, y, width, height, borderRadius);
        ctx.clip();
        ctx.drawImage(img, x, y, width, height);
        ctx.restore();
    };
    var drawLabel = function (ctx, x, y, width, height, text, color, rotation) {
        if (rotation === void 0) { rotation = 0; }
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(rotation);
        ctx.translate(-x, -y);
        ctx.lineWidth = 1;
        ctx.strokeStyle = color,
            ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
        drawRoundedRect(ctx, x, y, width, height, 5);
        ctx.fillStyle = color;
        ctx.font = 'bold 10px Lora';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, x + width / 2, y + height / 2);
        ctx.restore();
    };
    var barChartLabelIcons = {
        id: 'barChartLabelIcons',
        beforeDraw: function (chart, args, options) {
            if (options.enabled === false)
                return;
            var ctx = chart.ctx, _a = chart.chartArea, top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right, _b = chart.scales, x = _b.x, y = _b.y;
            var labels = chart.data.labels;
            labels.forEach(function (label, index) {
                if (!label || !label.icon || !label.kda)
                    return;
                var xCoord = x.getPixelForValue(index);
                var yCoord = bottom + 70;
                if (label.icon.endsWith('.png')) {
                    var img = imageCache.get(label.icon);
                    if (!img) {
                        img = new Image();
                        img.src = label.icon;
                        imageCache.set(label.icon, img);
                    }
                    if (img.complete && img.naturalHeight !== 0) {
                        var borderColor = label.team === 'blue' ? 'rgb(0, 163, 240)' : 'rgb(230, 10, 20)';
                        drawImageWithBorder(ctx, img, xCoord - 20, yCoord - 60, 40, 40, 2, borderColor, 4);
                    }
                }
                else {
                    ctx.fillStyle = '#FFFFFF';
                    ctx.font = '14px Lora';
                    ctx.textAlign = 'center';
                    ctx.fillText(label.icon, xCoord, yCoord - 30);
                }
                ctx.fillStyle = '#FFFFFF';
                ctx.font = '12px Lora';
                ctx.textAlign = 'center';
                ctx.fillText(label.kda, xCoord, yCoord);
                if (label.mvp) {
                    var starX = xCoord + 15;
                    var starY = yCoord - 55;
                    drawStar(ctx, starX, starY, 5, 2, 0.75, -Math.PI / 12);
                }
            });
        },
    };
    var barChartMiniLabelIcons = {
        id: 'barChartMiniLabelIcons',
        beforeDraw: function (chart, args, options) {
            if (options.enabled === false)
                return;
            var ctx = chart.ctx, _a = chart.chartArea, top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right, _b = chart.scales, x = _b.x, y = _b.y;
            var labels = chart.data.labels;
            var iconDim = options.iconDim;
            labels.forEach(function (label, index) {
                if (!label || !label.icon)
                    return;
                var xCoord = left - iconDim - 5;
                var yCoord = y.getPixelForValue(index);
                if (label.icon.endsWith('.png')) {
                    var img = imageCache.get(label.icon);
                    if (!img) {
                        img = new Image();
                        img.src = label.icon;
                        imageCache.set(label.icon, img);
                    }
                    if (img.complete && img.naturalHeight !== 0) {
                        var borderColor = label.team === 'blue' ? 'rgb(0, 163, 240)' : 'rgb(230, 10, 20)';
                        drawImageWithBorder(ctx, img, xCoord, yCoord - iconDim / 2, iconDim, iconDim, 2, borderColor, 2);
                    }
                }
                else {
                    ctx.fillStyle = '#FFFFFF';
                    ctx.font = '9px Lora';
                    ctx.textAlign = 'center';
                    ctx.fillText(label.icon, xCoord, yCoord);
                }
            });
        },
    };
    ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend, Filler, crosshair, lineChartIcons, barChartLabelIcons, barChartMiniLabelIcons, Zoom);
}
